import { styled } from '@spazious/dollhouse-theme';
import { Flex } from '@spazious/dollhouse-uikit';

export const HistoryTimelineBackdrop = styled(Flex)`
  position: relative;
  ::after {
    content: '';
    position: absolute;
    top: 50%;
    left: 0;
    right: 0;
    border-top: 2px solid var(--spz-sys-color-on-surface);
    z-index: -1;
  }
`;
